export { useProviderDetailsWidget } from './useProviderDetailsWidget';
